import { Common, ResolveState } from '../../../common';
import { Updater } from '../../../upgrade/models/updater-interface';
import { ErrorResult } from '../../../upgrade/models/error-result';
import { Logger } from '../../utils/logger';

/**
 * Updater for DeclareOverride errors.
 */
export class DeclareOverrideUpdater implements Updater {
    /**
     * The update function.
     * @param fileData the file data.
     * @param error the error object.
     * @returns The updated file data.
     */
    public update(fileData: string, error: ErrorResult): Promise<string> {
        if (!fileData) {
            Logger.error(`Cannot find file data`);
        }
        let result;
        const overrideNameRegex =  /Property\s+'([^']+)'(?=\s+will\s+overwrite\s+the\s+base\s+property)/;
        let overrideName: string;
        try {
            overrideName = error.message.match(overrideNameRegex)[1];
            Logger.log(`Found parameter name from error message as ${overrideName}`);
        } catch (error) {
            Logger.error(`Cannot find parameter name from ${error.message}`);
            return new Promise(resolve => resolve(''));
        }

        // const parameterRegex = new RegExp(`(public|protected|private)\\s+${overrideName}:\\s*\\w+\\s*;`, 'g');
        // work for below cases:
        // public input: string;
        // public input: string[];
        // Not yet support below cases:
        // public input: string<>;
        // public input: string<[]>;
        // public input: string<[]>[];
        // public input: string<[]>[][];
        const parameterRegex = new RegExp(`(public|protected|private)\\s+${overrideName}:\\s*(?:\\w+(\\[\\])?)(?:<\\w+>)?\\s*;`, 'g');
        Logger.log(`INFO - parameterRegex: ${parameterRegex}`);
        const parameters = fileData.match(parameterRegex);

        const validationParameterRegex = new RegExp(`declare\\s+(public|protected|private)\\s+${overrideName}:\\s*(?:\\w+(\\[\\])?)(?:<\\w+>)?\\s*;`, 'g');
        Logger.log(`INFO - validationParameterRegex: ${validationParameterRegex}`);
        const shouldUpdate = !!!fileData.match(validationParameterRegex);
        Logger.log(shouldUpdate ? `INFO - shouldUpdate: ${shouldUpdate}`: `INFO - shouldUpdate: ${shouldUpdate}`);

        Logger.log(`INFO - parameters: ${parameters}`);
        const replaceString = parameters ? parameters[0] : '';

        if (replaceString.length && shouldUpdate) {
            result = Common.replaceInString(fileData, parameterRegex, `declare ${replaceString}`);
            error.resolved = ResolveState.Resolved;
        } else {
            error.resolved = ResolveState.Resolved;
            Logger.error(`Cannot find replaceString`);
            return new Promise(resolve => resolve(''));
        }
        return new Promise(resolve => resolve(result));
    }
}
